module.exports = __webpack_public_path__ + "media/images/flags/64/Fiji-8f417fba254d625d3c4ded8ee645f956.png";